<template>
  <base-dialog
    ref="dialog"
    v-model="isVisible"
    v-model:dialog-reference="dialogRef"
    persistent
    :close-icon="false"
    :title="t('energyTypeSelection.title', {currentContractName})"
    :caption="$sanitize(t('energyTypeSelection.description'))"
    :actions="dialogActions"
  >
    <q-card class="q-dialog-plugin full-width">
      <div class="row">
        <div
          v-for="etConfig in selectionConfig"
          :key="etConfig.energyType"
          class="col-md-6 col-sm-6 col-xs-12"
          :class="`energy_type-${etConfig.energyType}`"
        >
          <q-card
            class="select-energy-type q-mx-md"
            bordered
          >
            <q-card-section class="select-energy-type items-center column">
              <q-avatar
                :icon="etConfig.rcProps.titleIcon"
                size="60px"
                color="white"
                text-color="primary"
                style="border: 1px solid var(--q-primary)"
              />
              <q-btn
                color="primary"
                outline
                :label="t(`energyTypes.${etConfig.energyType}`)"
                class="full-width q-px-lg wlk-btn q-mt-lg"
                @click="onDialogOK(etConfig.energyType)"
              />
            </q-card-section>
          </q-card>
        </div>
      </div>
    </q-card>
  </base-dialog>
</template>
<script>
import { toRefs, computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDialogPluginComponent, useQuasar } from 'quasar'
import { useSearchConfiguration } from 'src/helpers/searchConfiguration'
import { useUiUtils } from 'ui-common/base/composables/useUiUtils.pinia'
import BaseDialog from '@wilken8/portal-ui-common/components/BaseDialog.vue'

export default {
  name: 'EnergyTypeSelectionDialog',
  components: {
    BaseDialog
  },
  props: {
    currentContractName: {
      type: String,
      required: true
    },
    energyTypes: {
      type: Array,
      required: true
    }
  },
  emits: [
    ...useDialogPluginComponent.emits
  ],
  setup (props, { emit }) {
    const { t } = useI18n()
    const q = useQuasar()
    const propRefs = toRefs(props)

    const isVisible = ref(false)
    const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

    const availableConfig = useSearchConfiguration().getAvailableConfig()
    const uiUtils = useUiUtils()

    const isVertical = computed(() => q.screen.lt.sm)
    const selectionConfig = computed(() => propRefs.energyTypes.value.map(et => ({ energyType: et, ...availableConfig[et] })))

    const portalPath = '/__publicPath__/ssp-redirect'

    watch(isVisible, v => {
      if (!v) {
        onDialogHide()
      }
      emit('update:modelValue', v)
    })

    const dialogActions = computed(() => [
      {
        label: t('actions.backToCustomerPortal'),
        outline: true,
        color: 'primary',
        btnProps: {
          icon: 'undo',
          type: 'a',
          href: portalPath
        }
      }
    ])

    return {
      t,
      dialogActions,
      isVisible,
      dialogRef,
      onDialogHide,
      availableConfig,
      selectionConfig,
      isVertical,
      onDialogOK,
      portalPath,
      uiUtils
    }
  }
}
</script>
